import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6e34e774&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DocsWrapper: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/docs/DocsWrapper.vue').default})
